export default __webpack_public_path__ + "static/404-Error-Page-Pups_03-45f73bb33ea9250eb9d60d098b729582.png";